import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrashCanSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTrashCanSimple"><Path fillRule="evenodd" clipRule="evenodd" d="M7.86847 5H2.5V6.5H3.99815L5.08653 22H18.9135L20.0018 6.5H21.5V5H16.1315C15.6816 3.13507 14.003 1.75 12 1.75C9.99701 1.75 8.31844 3.13507 7.86847 5ZM9.43728 5H14.5627C14.1628 3.97583 13.1658 3.25 12 3.25C10.8342 3.25 9.83724 3.97583 9.43728 5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTrashCanSimple;
